<template>
  <div class="main-container" v-if="!isLoading">
    <div class="main-container-title-box">
      <div class="d-flex justify-center align-center">
        <div class="container-main-header-button">
          <v-btn depressed @click="back">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span>Редактировать</span>
        </div>
        <div></div>
      </div>
    </div>
    <div
      class="d-flex align-center main-container-info-box"
      style="margin: 0 24px 40px 24px"
    >
      <v-switch
        v-model="reception.isHidden"
        hide-details
        color="var(--app-green-1)"
      ></v-switch>
      <span>Отображать раздел</span>
    </div>

    <div class="main-container-info-box">
      <div class="info-block">
        <div class="info-block-title">Описание</div>
        <div>
          <v-textarea
            label="Текст"
            type="text"
            outlined
            :rules="rules"
            rows="1"
            auto-grow
            v-model="reception.description"
          ></v-textarea>
        </div>
      </div>

      <div class="info-block image-container">
        <div class="info-block-title">Изображение</div>
        <ImageCropper
          @imageDesktopBlob="
            (img) => {
              photo.image = img;
            }
          "
          @imageMobileBlob="
            (img) => {
              photo.imageMobile = img;
            }
          "
          @imageTabletBlob="
            (img) => {
              photo.imageTablet = img;
            }
          "
          :width="'100%'"
          :modelValue="newImage"
          :imgSrcProp="reception.originalImage"
          :imgSrcMobileProp="reception.smartphoneImage"
          :imgSrcTabletProp="reception.tabletImage"
          :placeToDisplay="'Изображение на фоне раздела'"
          :format="'Иконка раздела'"
          hideTitle
          hideTitleHint
        ></ImageCropper>
      </div>
      <div class="info-block image-container d-flex justify-space-between">
        <div class="info-block-title">Реакции раздела</div>
        <v-btn
          @click="openReactionDialog"
          style="width: auto !important"
          class="button-action-blue"
        >
          Добавить реакцию
        </v-btn>
      </div>
      <div v-if="items?.length > 0" class="reactions-table">
        <v-data-table
          :headers="tableHeaders"
          :items="reactionsList"
          item-key="id"
          :show-select="false"
          :disable-pagination="true"
          :hide-default-footer="true"
        >
          <template v-slot:body="props">
            <draggable
              :list="props.items"
              tag="tbody"
              @end="endDrag"
              :move="checkMove"
              :style="moveItems ? 'pointer-events: none;' : ''"
            >
              <tr v-for="(item, index) in props.items" :key="index">
                <td style="width: 24px">
                  <v-icon
                    small
                    style="cursor: pointer"
                    :disabled="moveItems ? true : false"
                  >
                    mdi-menu
                  </v-icon>
                </td>
                <td>{{ item.id }}</td>
                <td>
                  <img
                    style="width: 35px; height: 38px"
                    :src="item.imagePath"
                    alt=""
                  />
                </td>
                <td>{{ item.name }}</td>
                <td class="text-right">
                  <v-btn icon>
                    <v-icon
                      color="var(--app-red-1)"
                      @click.stop="deleteReaction(item.id)"
                    >
                      mdi-delete-outline
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </draggable>
          </template>
        </v-data-table>
      </div>
      <div class="container-block-footer-buttons">
        <div>
          <v-btn
            @click="saveReception"
            style="width: auto !important"
            class="button-accept"
          >
            Сохранить
          </v-btn>
        </div>
      </div>
    </div>
    <v-dialog
      width="570px"
      height="auto"
      persistent
      :content-class="'dialog-add-custom'"
      v-model="reactionDialog"
    >
      <v-card width="570px" height="auto" class="add-wrapper rounded-12">
        <v-card-title class="dialog-title-custom d-flex justify-space-between">
          <div class="title-custom">Добавить реакцию</div>
          <v-icon @click="closeReactionDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description-custom">
          <v-text-field
            style="margin-top: 20px"
            label="Название реакции"
            required
            type="text"
            outlined
            v-model="newReaction.name"
            :rules="rules"
          ></v-text-field>
          <v-file-input
            accept="image/jpeg, image/jpeg, image/png, image/svg+xml"
            outlined
            v-model="newReaction.file"
            :rules="rules"
            persistent-hint
            label="Добавить реакцию"
          ></v-file-input>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <v-btn
            style="width: 120px !important"
            @click="addNewReaction"
            class="button-accept ml-auto"
          >
            Добавить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ImageCropper from "@/components/inputs/ImageCropper.vue";
import draggable from "vuedraggable";

export default {
  components: {
    ImageCropper,
    draggable,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    reception: {},
    files: [],
    imageWidth: 0,
    newImage: null,

    isLoading: true,

    reactionDialog: false,
    reactionsList: [],
    newReaction: {},

    moveItems: false,
    selectedDrag: "",

    stubIcon: require("@/assets/phone.png"),

    rules: [(value) => !!value || "Обязательно к заполнению"],

    showBlock: false,

    items: [
      {
        id: 1,
        icon: require("@/assets/phone.png"),
        title: "ICON_NAME-1",
      },
      {
        id: 2,
        icon: require("@/assets/phone.png"),
        title: "ICON_NAME-2",
      },
      {
        id: 3,
        icon: require("@/assets/phone.png"),
        title: "ICON_NAME-3",
      },
    ],

    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "ID",
        sortable: false,
        value: "id",
      },
      {
        text: "Иконка",
        sortable: false,
        value: "icon",
      },
      {
        text: "Название",
        sortable: false,
        value: "title",
      },
      {
        text: "",
        sortable: false,
      },
    ],

    photo: {
      image: null,
      imageMobile: null,
      imageTablet: null,
    },
  }),
  methods: {
    back() {
      this.$emit("goToPage", "SettingsReception");
    },

    getReactions() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-reactions/list`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.reactionsList = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    deleteReaction(id) {
      this.$axios
        .delete(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-reactions/${id}`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            text: "Реакция успешно удалена",
            type: "success",
          });
          this.getReactions();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    async saveReception() {
      const promises = [];

      if (
        this.photo.image instanceof File ||
        this.photo.image instanceof Blob
      ) {
        promises.push(this.uploadImage(this.photo.image));
      }
      if (typeof this.photo.imageMobile !== "string") {
        promises.push(this.uploadImage(this.photo.imageMobile));
      }
      if (typeof this.photo.imageTablet !== "string") {
        promises.push(this.uploadImage(this.photo.imageTablet));
      }
      const [image, smartphoneImage, tabletImage] = await Promise.all(promises);
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-blocks`,
          {
            receptionOfCandidatesId: localStorage.getItem("electionId"),
            originalImage: image,
            smartphoneImage: smartphoneImage,
            tabletImage: tabletImage,
            description: this.reception.description,
            isHidden: !this.reception.isHidden,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.getReception();
          this.$store.commit("errorSet", {
            key: true,
            text: "Данные успешно сохранены",
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    getReception() {
      this.isLoading = true;
      const params = new URLSearchParams({
        receptionOfCandidateId: localStorage.getItem("electionId"),
      });
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/ksa-election-blocks/reception-of-candidate-block?${params}`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.reception = res.data;
          this.reception.isHidden = !this.reception.isHidden;
          this.photo.image = this.reception.originalImage;
          this.photo.imageMobile = this.reception.smartphoneImage;
          this.photo.imageTablet = this.reception.tabletImage;
          this.isLoading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    endDrag(evt) {
      this.moveItems = true;
      const body = {
        id: this.selectedDrag,
        index: evt.newIndex + 1,
      };
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV5 +
            "/reception-of-candidates-reactions/sort",
          body,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.getReactions();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    openReactionDialog() {
      this.reactionDialog = true;
    },
    closeReactionDialog() {
      this.reactionDialog = false;
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },

    async uploadImage(image) {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("path", "Reactions");

      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload",
        formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );

      return data;
    },

    async addNewReaction() {
      const reactionBody = {
        name: this.newReaction.name,
        imagePath: await this.uploadImage(this.newReaction.file),
      };
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/reception-of-candidates-reactions",
          reactionBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.newReaction.name = "";
          this.newReaction.file = null;
          this.reactionDialog = false;
          this.$store.commit("errorSet", {
            key: true,
            text: "Реакция успешно добавлена",
            type: "success",
          });
          this.getReactions();
        });
    },
  },
  created() {
    this.getReception();
    this.getReactions();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px;

    .container-main-header-button {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-left: 16px;
      }
    }

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .info-block {
      width: 50%;
      margin: 0 24px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .container-box-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
        margin-bottom: 16px;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .image-container {
      width: calc(100% - 48px);
      margin: 0 24px;
      margin-bottom: 32px;
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
    .container-block-footer-buttons {
      display: flex;
      justify-content: space-between;
      width: 50%;
      margin-top: 32px;
      padding-left: 32px;
    }
  }
  .reactions-table {
    margin: 0 24px;
  }
}

.dialog-add-custom {
  .add-wrapper {
    .dialog-title-custom {
      .title-custom {
        font-weight: 500;
        font-size: 24px;
        line-height: 20px;
        color: var(--app-dark-blue-3);
      }
    }
    .dialog-description-custom {
      padding: 0 24px;
      .description-custom {
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
      }
    }
  }
}
</style>
